import { Component, OnInit, Inject } from '@angular/core';
import { combineLatest, map, Subject, takeUntil } from 'rxjs';
import { FuseConfigService } from '@fuse/services/config';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { DOCUMENT } from '@angular/common';
import { ResponsiveBrandManagementService } from '@feature/core/responsive-brand/responsive-brand-management.service';

@Component({
  selector: 'mojo-empty-faq-layout',
  templateUrl: './empty-faq-layout.component.html'
})

export class EmptyFaqLayoutComponent implements OnInit {

  scheme: 'dark' | 'light';
  theme: string;
  private unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   * @param fuseConfigService
   * @param fuseMediaWatcherService
   * @param document
   */
  constructor(
    private fuseConfigService: FuseConfigService,
    private fuseMediaWatcherService: FuseMediaWatcherService,
    brandService: ResponsiveBrandManagementService, 
    @Inject(DOCUMENT) private document: any) {
        brandService.initialiseBrandManagementService();
    }

    /**
     * On Init
     */
  ngOnInit(): void {
    this.loadTemplateCss();

    // Set the theme and scheme based on the configuration
    combineLatest([
      this.fuseConfigService.config$,
      this.fuseMediaWatcherService.onMediaQueryChange$(['(prefers-color-scheme: dark)', '(prefers-color-scheme: light)'])
    ]).pipe(
        takeUntil(this.unsubscribeAll),
        map(([config, mql]) => {

            const options = {
                scheme: config.scheme,
                theme : config.theme
            };

            // If the scheme is set to 'auto'...
            if ( config.scheme === 'auto' )
            {
                // Decide the scheme using the media query
                options.scheme = mql.breakpoints['(prefers-color-scheme: dark)'] ? 'dark' : 'light';
            }

            return options;
        })
    ).subscribe((options) => {

        // Store the options
        this.scheme = options.scheme;
        this.theme = options.theme;

        // Update the scheme and theme
        this._updateScheme();
        this._updateTheme();
    });
  }

  loadTemplateCss() : void {

    // Order dependant list of scss bundles configured in angular.json
    const bundleNames = [
            "resp-fuse-tailwind",
            "resp-fuse-themes",
            "resp-vendors",
            "resp-fuse-main",
            "resp-styles",
            "resp-tailwind"                
    ];

    bundleNames.forEach(bundleName => {
        const lazyStyleElement = document.createElement('link');
        lazyStyleElement.rel = 'stylesheet';
        lazyStyleElement.href = `/${bundleName}.css`;            
        document.body.appendChild(lazyStyleElement); 
    });
  }

  /**
     * Update the selected scheme
     *
     * @private
     */
   private _updateScheme(): void
   {
       // Remove class names for all schemes
       this.document.body.classList.remove('light', 'dark');

       // Add class name for the currently selected scheme
       this.document.body.classList.add(this.scheme);
   }

   /**
    * Update the selected theme
    *
    * @private
    */
   private _updateTheme(): void
   {
       // Find the class name for the previously selected theme and remove it
       this.document.body.classList.forEach((className: string) => {
           if ( className.startsWith('theme-') )
           {
               this.document.body.classList.remove(className, className.split('-')[1]);
           }
       });

       // Add class name for the currently selected theme
       this.document.body.classList.add(this.theme);
   }
}